import type { OfferRow } from "./offersPage";

export type OfferView = "ready" | "activate" | "history";
export function readOfferView(value: string | null, hash = ""): OfferView {
  return value === "activate" || (!value && hash === "#find") ? "activate" : value === "history" ? "history" : "ready";
}

/** Missing is uncertainty, not redemption or activation. */
export function offerView(row: OfferRow): OfferView | "confirmation" {
  if (row.used || row.expired) return "history";
  if (row.missing_since) return "confirmation";
  return row.enrolled ? "ready" : "activate";
}

export function filterTrackedOffers(rows: OfferRow[], query: string, cardId: number | null) {
  const needle = query.trim().toLocaleLowerCase();
  return rows.filter(row => (!cardId || row.card_id === cardId) && row.merchant.toLocaleLowerCase().includes(needle));
}
